(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["a-product-sticky-atc"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('l-product-sticky-atc')) {
		class ProductStickyATC extends HTMLElement {
			connectedCallback() {
				this.updateVisibility = this.updateVisibility.bind(this)
				this.onVariantChange = this.onVariantChange.bind(this)
				this.variantPicker = document.querySelector('#product-variant-picker')
				this.variantInput = this.querySelector('[data-sticky-atc-variant-id]')
				this.submitButton = this.querySelector('[data-sticky-atc-submit]')
				this.variantSelectionEl = this.getVariantSelectionHost()

				this._variantSyncGen = 0

				if (this.variantSelectionEl) {
					this.variantSelectionEl.addEventListener('variant-change', this.onVariantChange)
					queueMicrotask(() => this.requestVariantSyncFromSelection())
				}

				if (this.variantPicker) {
					window.addEventListener('scroll', this.updateVisibility, { passive: true })
					window.addEventListener('resize', this.updateVisibility)
					this.updateVisibility()
				}
			}

			disconnectedCallback() {
				if (this.variantSelectionEl) {
					this.variantSelectionEl.removeEventListener('variant-change', this.onVariantChange)
				}

				if (this.variantPicker) {
					window.removeEventListener('scroll', this.updateVisibility)
					window.removeEventListener('resize', this.updateVisibility)
				}
			}

			getVariantSelectionHost() {
				const productId = this.dataset.productId

				if (productId) {
					const scoped = document.querySelector(
						`[data-product-form][data-product-id="${productId}"] variant-selection[data-variant-selection]`
					)
					if (scoped) return scoped
				}

				return document.querySelector('variant-selection[data-variant-selection]')
			}

			/**
			 * Read the current variant from `<variant-selection>` (same as theme JS), not only
			 * `event.detail`, and drop stale async results so a slow initial `getVariant()` cannot
			 * overwrite state after a newer `variant-change` (matches `selectCallback` in utilities.js).
			 */
			requestVariantSyncFromSelection() {
				if (!this.variantSelectionEl || typeof this.variantSelectionEl.getVariant !== 'function') return

				const gen = ++this._variantSyncGen

				this.variantSelectionEl.getVariant().then((variant) => {
					if (gen !== this._variantSyncGen) return
					this.syncStickyAtc(variant)
				})
			}

			onVariantChange() {
				this.requestVariantSyncFromSelection()
			}

			syncStickyAtc(variant) {
				if (!this.variantInput || !this.submitButton) return

				const labelAdd = this.dataset.labelAddToCart || 'Add to cart'
				const labelSoldOut = this.dataset.labelSoldOut || 'Sold Out'
				const labelUnavailable = this.dataset.labelUnavailable || 'Unavailable'

				const hasVariant = Boolean(variant && variant.id)
				const purchasable = Boolean(hasVariant && variant.available)

				if (hasVariant) {
					this.variantInput.value = String(variant.id)
				} else {
					this.variantInput.value = ''
				}

				if (!hasVariant) {
					this.submitButton.textContent = labelUnavailable
				} else if (hasVariant && !variant.available) {
					this.submitButton.textContent = labelSoldOut
				} else {
					this.submitButton.textContent = labelAdd
				}

				this.submitButton.disabled = !purchasable
			}

			updateVisibility() {
				if (!this.variantPicker) return

				const pickerTop = this.variantPicker.getBoundingClientRect().top + window.scrollY
				const showThreshold = pickerTop + 400
				const shouldShow = window.scrollY > showThreshold

				this.classList.toggle('is-showing', shouldShow)
			}
		}

		customElements.define('l-product-sticky-atc', ProductStickyATC)
	}
  } catch(e) { console.error(e); }
})();

})();
